import { render, staticRenderFns } from "./AlignmentSettings.vue?vue&type=template&id=25ce1c6c&scoped=true"
import script from "./AlignmentSettings.vue?vue&type=script&lang=js"
export * from "./AlignmentSettings.vue?vue&type=script&lang=js"
import style0 from "./AlignmentSettings.vue?vue&type=style&index=0&id=25ce1c6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "25ce1c6c",
  null
  
)

export default component.exports